import React from 'react';
import PropTypes from 'prop-types';
import { Paper, PaperTitle } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';

import PatientHistory from 'containers/TransmissionReport/PatientHistory';
import DeviceStatusInfo from 'containers/DeviceStatusInfo';
import DeviceStatusPicker from 'containers/DeviceStatusPicker';
import DeviceTransmissionReport from 'containers/DeviceTransmissionReport';
import MedicalTherapyInfo from 'containers/MedicalTherapyInfo';
import DetailedEPReport from 'containers/DetailedEPReport';

import DeviceInformationFrom from 'containers/DeviceInformation/DeviceInformationFrom';

import { RESEARCHER, DOCTOR, TECHNICIAN } from 'constants/userRoles';
import { REGISTERED } from 'constants/observationStatuses';
import DeviceInformation from './DeviceInformation';

const TransmissionReportContent = ({
  alertValue,
  batteryLife,
  lastUpdated,
  pacingValue,
  patientId,
  reportId,
  role,
  shockValue,
  shocks,
  status,
  t,
}) => (
  <Paper>
    <PaperTitle withBorder>{t('patient.transmissionReportSummary')}</PaperTitle>
    <DeviceTransmissionReport patientId={patientId} reportId={reportId} />

    {status === REGISTERED && (role === DOCTOR || role === TECHNICIAN) ? (
      <DeviceInformationFrom reportId={reportId} />
    ) : (
      <DeviceInformation
        shocks={shocks}
        shockValue={shockValue}
        pacingValue={pacingValue}
        lastUpdated={lastUpdated}
        batteryLife={batteryLife}
        alertValue={alertValue}
      />
    )}

    {(role === RESEARCHER || role === DOCTOR) && <PatientHistory />}

    <DetailedEPReport reportId={reportId} />

    {status !== REGISTERED && (
      <>
        <DeviceStatusInfo />
        <MedicalTherapyInfo />
      </>
    )}
    {role === DOCTOR && status === REGISTERED && <DeviceStatusPicker />}
  </Paper>
);

TransmissionReportContent.propTypes = {
  alertValue: PropTypes.bool.isRequired,
  batteryLife: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string.isRequired,
  pacingValue: PropTypes.string.isRequired,
  patientId: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  shockValue: PropTypes.string.isRequired,
  shocks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dateTime: PropTypes.string.isRequired,
    }),
  ).isRequired,
  status: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TransmissionReportContent);
